
import Account from './Account';
import Dashboard from './Dashboard/Routes';
import Invemtory from './Inventory';
import Menu from './Menu/Routes';
import Voucher from './Voucher';
import Reports from './Reports/Routes';
import Settings from './Settings/Routes';
import WeeklyMenu from './WeeklyMenu/Routes';

export default [...Account, ...Dashboard, ...Invemtory, ...Menu, ...Reports, ...Voucher, ...Settings, ...WeeklyMenu];